module.exports = __webpack_public_path__ + "static/media/wwi.9bf63cf8.jpg";